// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-full {
  width: 100%;
}

.edit-modal .modal-container {
  width: 500px !important;
  height: 585px !important;
  overflow: auto;
  padding: 0.5rem !important;
}
.edit-modal .modal-container .modal-header {
  padding: 0 !important;
  border-bottom: 0 !important;
}
.edit-modal .modal-container .modal-content {
  height: auto;
  overflow: auto;
  padding: 0 !important;
}
.edit-modal button {
  width: 420px;
}

.mark-sold-modal .modal-container {
  width: 480px !important;
  height: 285px !important;
}
.mark-sold-modal .modal-container .modal-header {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.mark-sold-modal .modal-container .modal-content {
  height: auto;
  overflow: auto;
  padding: 1.5rem !important;
}
.mark-sold-modal button {
  width: 200px !important;
}

.delete-modal .modal-container {
  width: 380px !important;
  height: auto !important;
  justify-content: center;
  align-items: center;
}
.delete-modal .modal-container .modal-header {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.delete-modal .modal-container .modal-content {
  height: auto;
  overflow: auto;
}
.delete-modal .modal-footer {
  width: 100% !important;
}
.delete-modal button {
  width: 100% !important;
}
.delete-modal button.primary {
  background: #D92D20;
}
.delete-modal button.primary:hover {
  background: #D92D20;
  opacity: 0.9;
}

/* Media queries for larger screens */
@media (min-width: 370px) and (max-width: 635px) { /* sm breakpoint in Tailwind CSS */
  .edit-modal .modal-container {
    width: 330px !important;
    height: auto !important;
    padding: 0 !important;
  }
  .mark-sold-modal .modal-container {
    width: 330px !important;
    height: auto !important;
  }
  .mark-sold-modal button {
    width: 100% !important;
  }
  .delete-modal .modal-container {
    width: 330px !important;
    height: auto !important;
  }
  .delete-modal .modal-container button {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/user-listing/components/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAGE;EACC,uBAAA;EACA,wBAAA;EACA,cAAA;EACA,0BAAA;AAAH;AACG;EACM,qBAAA;EACA,2BAAA;AACT;AACG;EACC,YAAA;EACA,cAAA;EACA,qBAAA;AACJ;AAGG;EACC,YAAA;AADJ;;AAKI;EACE,uBAAA;EACA,wBAAA;AAFN;AAGM;EACG,2BAAA;EACA,qBAAA;AADT;AAGM;EACC,YAAA;EACA,cAAA;EACA,0BAAA;AADP;AAIM;EACE,uBAAA;AAFR;;AAMI;EACE,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AAHN;AAIM;EACG,2BAAA;EACA,qBAAA;AAFT;AAIM;EACC,YAAA;EACA,cAAA;AAFP;AAMM;EACE,sBAAA;AAJR;AAMM;EACE,sBAAA;AAJR;AAMM;EACE,mBAAA;AAJR;AAMM;EACE,mBAAA;EACA,YAAA;AAJR;;AASA,qCAAA;AACA,mDAAA,kCAAA;EAEI;IACE,uBAAA;IACA,uBAAA;IACA,qBAAA;EAPJ;EAYE;IACE,uBAAA;IACA,uBAAA;EAVJ;EAYE;IACE,sBAAA;EAVJ;EAeE;IACE,uBAAA;IACA,uBAAA;EAbJ;EAcI;IACE,sBAAA;EAZN;AACF","sourcesContent":[".w-full{\n  width:100% ;\n}\n\n.edit-modal {\n  .modal-container {\n   width: 500px !important;\n   height: 585px !important;\n   overflow: auto;\n   padding: 0.5rem !important;\n   .modal-header{\n         padding: 0 !important;\n         border-bottom:0 !important;\n   }\n   .modal-content {\n    height: auto;\n    overflow: auto;\n    padding:0 !important;\n   \n  }\n   }\n   button{\n    width: 420px;\n   }\n  }\n  .mark-sold-modal{\n    .modal-container {\n      width: 480px !important;\n      height: 285px !important;\n      .modal-header{\n         border-bottom:0 !important;\n         padding: 0 !important;\n      }\n      .modal-content {\n       height: auto;\n       overflow: auto;\n       padding:1.5rem !important;\n     }\n      }\n      button{\n        width:200px !important;\n      }\n  }\n  .delete-modal{\n    .modal-container {\n      width: 380px !important;\n      height: auto !important;\n      justify-content: center;\n      align-items: center;\n      .modal-header{\n         border-bottom:0 !important;\n         padding: 0 !important;\n      }\n      .modal-content {\n       height: auto;\n       overflow: auto;\n     }\n      }\n\n      .modal-footer {\n        width: 100% !important;\n      }\n      button{\n        width:100% !important;\n      }\n      button.primary{\n        background: theme('colors.error');\n      }\n      button.primary:hover{\n        background: theme('colors.error');\n        opacity: 0.9;\n      }\n  }\n  \n\n/* Media queries for larger screens */\n@media (min-width: 370px ) and (max-width:635px)  { /* sm breakpoint in Tailwind CSS */\n  .edit-modal {\n    .modal-container {\n      width: 330px !important;\n      height: auto !important;\n      padding: 0 !important;\n    }\n  }\n\n  .mark-sold-modal {\n    .modal-container {\n      width: 330px !important;\n      height: auto !important;\n    }\n    button{\n      width:100% !important;\n    }\n    }\n\n  .delete-modal {\n    .modal-container {\n      width: 330px !important;\n      height: auto !important;\n      button{\n        width:100% !important;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
